import React from 'react'

const ForgotPasswordPage: React.FC = () => {
  return (
    <div>
      <h1>Forgot Password</h1>
      {/* Add your forgot password form component here */}
    </div>
  )
}

export default ForgotPasswordPage
